<template>
    <v-card>
        <v-card-title>
            Level progress
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="1" style="height: 45px;">
                    <v-subheader>Levels</v-subheader>
                </v-col>
                <v-col cols="1" style="height: 45px;">
                    <v-text-field v-model="categoriesStart" label="start" hint="" persistent-hint outlined dense/>
                </v-col>
                <v-col cols="1" style="height: 45px;">
                    <v-text-field v-model="categoriesEnd" label="end" hint="" persistent-hint outlined dense/>
                </v-col>
                <v-col cols="2" md="2" style="height: 45px;">
                    <!--                        <v-autocomplete v-model="platform" :items="['Android', 'iOS', 'Steam']" label="Platforms" multiple clearable outlined dense small-chips deletable-chips/>-->
                    <v-select v-model="platform" :items="$store.getters.platforms" label="Platform" clearable outlined dense small-chips/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
<!--                    <v-text-field v-model="appVersion" label="App version" clearable outlined dense/>-->
                    <v-combobox v-model="appVersion" :items="$store.getters.versions" label="App version" clearable outlined dense small-chips/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-btn class="mr-4" @click="loadProgress" align="left" :loading="loading">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div class="example">
                        <apexcharts height="350" type="bar" :options="chartOptions" :series="series"></apexcharts>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    import VueApexCharts from 'vue-apexcharts'
    import store from "../store";
    //import users from "../store/users";

    export default {
        name: 'Chart',
        components: {apexcharts: VueApexCharts},
        data: () => ({
            categoriesStart: '1',
            categoriesEnd: '131',
            platform: '',
            appVersion: store.getters.versions[0],

            categories: []
        }),
        computed: {
            series() {
                return [{name: 'users', data: store.getters["users/getUserProgress"]}]
            },
            chartOptions(){
                return {
                    chart: {
                        height: 350,
                        type: 'bar',
                        stacked: true,
                        toolbar: {show: true},
                        zoom: {enabled: true}
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            dataLabels: {
                                position: 'top', // top, center, bottom
                                hideOverflowingLabels: false
                            },
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (val) {
                            let sum = store.getters["users/getUserProgressSum"]
                            return (sum == 0 ? 0.0 : (val / sum) * 100).toFixed(1) + "%"
                        },
                        offsetY: -20,
                        style: {
                            fontSize: '12px',
                            colors: ["#304758"]
                        },
                    },
                    xaxis: {
                        categories: this.categories,
                        position: 'bottom',
                        axisBorder: {show: false},
                        axisTicks: {show: false},
                        crosshairs: {
                            fill: {
                                type: 'gradient',
                                    gradient: {
                                    colorFrom: '#D8E3F0',
                                        colorTo: '#BED1E6',
                                        stops: [0, 100],
                                        opacityFrom: 0.4,
                                        opacityTo: 0.5,
                                }
                            }
                        },
                        tooltip: {enabled: true},
                    },
                    yaxis: {
                        axisBorder: {show: false},
                        axisTicks: {show: false},
                        labels: {
                            show: true,
                            formatter: function (val) {
                                return val// + "%";
                            }
                        }
                    }
                }
            },
            loading() {
                return this.$store.state.loading;
            }
        },
        methods: {
            loadProgress() {
                let categories = [];
                for (let i = parseInt(this.categoriesStart); i <= parseInt(this.categoriesEnd); ++i) {
                    categories.push(i);
                }
                this.categories = categories;
                //this.chartOptions = {chart: {id: 'basic-bar'}, xaxis: {categories: categories}}
                store.dispatch("users/loadUserProgress", {
                    start: parseInt(this.categoriesStart),
                    end: parseInt(this.categoriesEnd),
                    platform: this.platform,
                    version: this.appVersion
                });
            },
        }
    }
</script>
